<template>
  <div class="app-text-label container">
    <div class="label" style="color: var(--surface-600)">{{ label }}</div>
    <div class="value">
      <span v-if="value">{{ value }}</span>
      <span v-else>
        <slot></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTextLabel',
  props: {
    label: String,
    value: String,
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
}
.label {
  margin-bottom: 5px;
}
</style>
